import type { ReactNode } from 'react';
import type { SpacingTypes } from '@etg/wings';
import { Columns, PageBlock } from '@etg/wings';
import { css, cx } from '@eti/styles';
import { useTranslation } from '@eti/providers';

const blockStyles = css`
  background-color: #fff;
  overflow-x: hidden;
  padding-block: 16px;
`;

interface UniqueSellingPointWrapperProps {
  children: ReactNode;
  className?: string;
  dataTestId: string;
  spacing?: SpacingTypes;
}

const UniqueSellingPointWrapper = ({
  children,
  className,
  dataTestId,
  spacing = 24,
}: UniqueSellingPointWrapperProps) => {
  const { t } = useTranslation();

  return (
    <PageBlock
      aria-label={t('ScreenReader.USPSection.AriaLabel.Text')}
      as="section"
      className={cx(blockStyles, className)}
      data-testid={dataTestId}
      role="region"
    >
      <Columns
        aria-label={t('ScreenReader.USPSection.List.AriaLabel.Text')}
        as="ul"
        spacing={spacing}
      >
        {children}
      </Columns>
    </PageBlock>
  );
};

export default UniqueSellingPointWrapper;
